"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSubTitle = exports.FormWrapper = exports.Form = void 0;
const containers_1 = require("@pulse-web-ui/containers");
const theme_1 = require("@pulse-web-ui/theme");
exports.Form = (0, theme_1.styled)(containers_1.WidgetContainer) `
  &:last-child {
    margin-bottom: 0;
  }
`;
exports.FormWrapper = theme_1.styled.div `
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;
exports.StyledSubTitle = theme_1.styled.span `
  white-space: normal;

  ${theme_1.media.desktop} {
    white-space: break-spaces;
  }
`;
